import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './EYDiscountSurchargeTable.metadata.json5';
import './EYDiscountSurchargeTable.messages';

const getCell = (items, index, property) => {
    //  console.log('items: ', items[property.id])
    return !_.isObject(items[property.id]) ? items[property.id] : null;
};

export function EYDiscountSurchargeTable({ data }) {
    let excludeSurcharges = data !== null && data !== undefined ? data : [];
    excludeSurcharges = data.filter((value) => {
        return !(value.name.includes('Surcharge') || value.name.includes('Exposure'));
    });
    const overrides = {
        eyDiscountSurchargeTable: {
            data: excludeSurcharges
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            getCell: getCell
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={data}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

EYDiscountSurchargeTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({}))
};

EYDiscountSurchargeTable.defaultProps = {
    data: []
};


export default EYDiscountSurchargeTable;
